function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1952(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30.12,
    height: 21.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6133333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 10.84,
    fontFamily: "Arial"
  }, "\n        Vinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.68,
    width: 30.12,
    height: 26.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 34.82,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 47.96,
    width: 30.12,
    height: 26.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.381666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 61.105000000000004,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 74.25,
    width: 30.12,
    height: 26.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.362
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 87.655,
    fontFamily: "Arial"
  }, "\n        Noble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 101.06,
    width: 30.12,
    height: 29.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.913333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 115.8,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.54,
    width: 30.12,
    height: 30.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 145.64999999999998,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 160.76,
    width: 30.12,
    height: 31.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 176.635,
    fontFamily: "Arial"
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192.5,
    width: 30.12,
    height: 37.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 211.145,
    fontFamily: "Arial"
  }, "\n        Morrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.8,
    width: 30.12,
    height: 38.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.302857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 248.88,
    fontFamily: "Arial"
  }, "\n        Hocking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 267.96,
    width: 30.12,
    height: 38.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.302857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 287.39,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 306.82,
    width: 30.12,
    height: 39.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 326.425,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 346.02,
    width: 30.12,
    height: 41.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.302857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 366.79999999999995,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 387.58,
    width: 30.12,
    height: 42.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.024
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 408.645,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 429.71,
    width: 30.12,
    height: 43.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.302857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 451.22999999999996,
    fontFamily: "Arial"
  }, "\n        Wyandot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 472.75,
    width: 30.12,
    height: 43.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 494.54,
    fontFamily: "Arial"
  }, "\n        Gallia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 516.34,
    width: 30.12,
    height: 44.11,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.024
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 538.395,
    fontFamily: "Arial"
  }, "\n        Meigs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560.45,
    width: 30.12,
    height: 45.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.024
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 583.445,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 606.44,
    width: 30.12,
    height: 46.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.024
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 629.745,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 653.05,
    width: 30.12,
    height: 46.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.302857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.06,
    y: 676.525,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 0,
    width: 35.87,
    height: 40.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1739999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.055,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.99,
    y: 0,
    width: 38.2,
    height: 40.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.09,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.19,
    y: 0,
    width: 38.81,
    height: 40.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.595,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Pickaway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 0,
    width: 39.2,
    height: 40.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.6,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.2,
    y: 0,
    width: 39.63,
    height: 40.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.015,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.83,
    y: 0,
    width: 39.66,
    height: 40.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.66000000000003,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.49,
    y: 0,
    width: 41.26,
    height: 40.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.12,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.75,
    y: 0,
    width: 42.22,
    height: 40.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.09375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.86,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Defiance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.97,
    y: 0,
    width: 42.83,
    height: 40.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.791666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.38500000000005,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Geauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.8,
    y: 0,
    width: 43.02,
    height: 40.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.791666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 409.31,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Preble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.82,
    y: 0,
    width: 43.04,
    height: 40.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.09375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.34,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Williams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.86,
    y: 0,
    width: 43.68,
    height: 40.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.527777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.7,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.54,
    y: 0,
    width: 44.78,
    height: 40.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.791666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.93,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.32,
    y: 0,
    width: 44.79,
    height: 40.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.09375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.715,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.11,
    y: 0,
    width: 46.43,
    height: 40.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.791666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.325,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 653.54,
    y: 0,
    width: 46.46,
    height: 40.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.791666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.77,
    y: 20.375,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 40.75,
    width: 47.8,
    height: 40.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 60.78,
    fontFamily: "Arial"
  }, "\n        Van_Wert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 80.82,
    width: 47.8,
    height: 40.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.701666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 100.925,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 121.02,
    width: 47.8,
    height: 41.33,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.16625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 141.685,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 162.36,
    width: 47.8,
    height: 43.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.811111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 184.01000000000002,
    fontFamily: "Arial"
  }, "\n        Coshocton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 205.66,
    width: 47.8,
    height: 43.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 227.47,
    fontFamily: "Arial"
  }, "\n        Auglaize\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 249.28,
    width: 47.8,
    height: 43.98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.796
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 271.27,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 293.26,
    width: 47.8,
    height: 45.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.67125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 315.945,
    fontFamily: "Arial"
  }, "\n        Guernsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 338.63,
    width: 47.8,
    height: 47.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 362.515,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 386.41,
    width: 47.8,
    height: 49.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.828571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 410.93,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 435.44,
    width: 47.8,
    height: 49.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.966666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 460.28499999999997,
    fontFamily: "Arial"
  }, "\n        Athens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 485.13,
    width: 47.8,
    height: 50.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 510.615,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 536.1,
    width: 47.8,
    height: 51.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.966666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 561.84,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 587.57,
    width: 47.8,
    height: 56.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 615.58,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.12,
    y: 643.59,
    width: 47.8,
    height: 56.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.828571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.019999999999996,
    y: 671.7950000000001,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 40.75,
    width: 47.88,
    height: 56.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.86,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 40.75,
    width: 49,
    height: 56.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.3,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Sandusky\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 40.75,
    width: 49.54,
    height: 56.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.954
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.57000000000002,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.34,
    y: 40.75,
    width: 49.66,
    height: 56.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.931999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.17000000000002,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Darke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 40.75,
    width: 49.68,
    height: 56.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.84,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.68,
    y: 40.75,
    width: 50.89,
    height: 56.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.7225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.125,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.57,
    y: 40.75,
    width: 51.41,
    height: 56.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.8525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.275,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Ross\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.98,
    y: 40.75,
    width: 51.42,
    height: 56.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.69,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.4,
    y: 40.75,
    width: 53.52,
    height: 56.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.15999999999997,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Clermont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.92,
    y: 40.75,
    width: 54.72,
    height: 56.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 558.28,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.64,
    y: 40.75,
    width: 56.43,
    height: 56.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.855,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Fairfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.07,
    y: 40.75,
    width: 57.93,
    height: 56.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.451666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.0350000000001,
    y: 69.105,
    fontFamily: "Arial"
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 97.46,
    width: 63.91,
    height: 54.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 124.845,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 152.23,
    width: 63.91,
    height: 54.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.976
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 179.67,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 207.11,
    width: 63.91,
    height: 62.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 238.175,
    fontFamily: "Arial"
  }, "\n        Miami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 269.23,
    width: 63.91,
    height: 63.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.092857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 301.055,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 332.88,
    width: 63.91,
    height: 66.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.129999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 366.135,
    fontFamily: "Arial"
  }, "\n        Licking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 399.39,
    width: 63.91,
    height: 69.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.101111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 434.335,
    fontFamily: "Arial"
  }, "\n        Muskingum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 469.28,
    width: 63.91,
    height: 72.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.391
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 505.48499999999996,
    fontFamily: "Arial"
  }, "\n        Tuscarawas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 541.7,
    width: 63.91,
    height: 78.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.101111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 580.9200000000001,
    fontFamily: "Arial"
  }, "\n        Ashtabula\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.92,
    y: 620.14,
    width: 63.91,
    height: 79.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.651666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 660.0699999999999,
    fontFamily: "Arial"
  }, "\n        Scioto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.83,
    y: 97.46,
    width: 71.41,
    height: 72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.8525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.53500000000003,
    y: 133.45999999999998,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.24,
    y: 97.46,
    width: 74.55,
    height: 72,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.51500000000001,
    y: 133.45999999999998,
    fontFamily: "Arial"
  }, "\n        Allen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.79,
    y: 97.46,
    width: 74.68,
    height: 72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.13,
    y: 133.45999999999998,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.47,
    y: 97.46,
    width: 78.07,
    height: 72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.285714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.505,
    y: 133.45999999999998,
    fontFamily: "Arial"
  }, "\n        Belmont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.54,
    y: 97.46,
    width: 84.16,
    height: 72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.62,
    y: 133.45999999999998,
    fontFamily: "Arial"
  }, "\n        Columbiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.7,
    y: 97.46,
    width: 86.56,
    height: 72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.98,
    y: 133.45999999999998,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.27,
    y: 97.46,
    width: 88.73,
    height: 72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.635,
    y: 133.45999999999998,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.83,
    y: 169.45,
    width: 113.36,
    height: 70.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.683333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.51000000000002,
    y: 204.5,
    fontFamily: "Arial"
  }, "\n        Lorain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.83,
    y: 239.56,
    width: 113.36,
    height: 77.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.948333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.51000000000002,
    y: 278.405,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.83,
    y: 317.25,
    width: 113.36,
    height: 89.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.22125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.51000000000002,
    y: 362.135,
    fontFamily: "Arial"
  }, "\n        Trumbull\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.83,
    y: 407.02,
    width: 113.36,
    height: 141.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.51000000000002,
    y: 477.615,
    fontFamily: "Arial"
  }, "\n        Mahoning\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.83,
    y: 548.21,
    width: 113.36,
    height: 151.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.672
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.51000000000002,
    y: 624.105,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 169.45,
    width: 139.19,
    height: 163.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.919
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.78499999999997,
    y: 251.14499999999998,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.38,
    y: 169.45,
    width: 152.78,
    height: 163.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.77,
    y: 251.14499999999998,
    fontFamily: "Arial"
  }, "\n        Lucas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.16,
    y: 169.45,
    width: 152.84,
    height: 163.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.473333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.5799999999999,
    y: 251.14499999999998,
    fontFamily: "Arial"
  }, "\n        Summit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 332.85,
    width: 208.8,
    height: 146.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.27125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.59000000000003,
    y: 405.935,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 479.02,
    width: 208.8,
    height: 220.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.59000000000003,
    y: 589.51,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.99,
    y: 332.85,
    width: 236.01,
    height: 367.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 29.50125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.995,
    y: 516.425,
    fontFamily: "Arial"
  }, "\n        Cuyahoga\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1952);
export default __webpack_public_path__ + "static/media/1952.bfa9c64507243bfe9d9acabe1c29868a.svg";
export { ForwardRef as ReactComponent };